import { createFileRoute } from "@tanstack/react-router";
import { collectionSchema } from "src/features/collection/components/route";
import { Component } from "src/features/collection/components/site-list";

export const Route = createFileRoute("/_layout/site/$siteSlug/collection")({
  component: Component,
  validateSearch: (search) => collectionSchema.parse(search),
});
